import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Pagination from "./Pagination";
import _ from "lodash";
import "../style/statisticsTable.css";

function StatisticsTable({ items }) {
  const pageSize = 4;
  const [currentPage, setCurrentPage] = useState(1);
  const [programs, setPrograms] = useState([]);
  let navigate = useNavigate();

  const handleOnPageClick = (number) => {
    setCurrentPage(number);
  };

  const paginate = () => {
    const start = (currentPage - 1) * pageSize;
    return _(items).slice(start).take(pageSize).value();
  };

  useEffect(() => {
    const paginatedProgramsArray = paginate(items);
    setPrograms(paginatedProgramsArray);
  }, [items, currentPage]);

  return (
    <div className="table_container">
      <table className="table farsi">
        <thead>
          <tr>
            <th className="farsi-header-for-program-table">عنوان</th>
            <th className="farsi-header-for-program-table">‌آسیب‌پذیری‌ها</th>
          </tr>
        </thead>
        <tbody>
          {programs.map((p) => (
            <tr
              className="program-table-item"
              key={p._id}
              onClick={() => {
                const str = `/cpes/${p.cpeId}/cves`;
                navigate(str, { replace: false });
              }}
            >
              <td className="col-11 row-title">{p.title}</td>
              <td className="col-1 ">
                <div className="cve-count">{p.cves.length}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Pagination
        className="pagination-container"
        countOfItems={items.length}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageClicked={handleOnPageClick}
      ></Pagination>
    </div>
  );
}

export default StatisticsTable;
